export default "__VITE_ASSET__Doa9z0sA__"